import type { AppMessageData, EmbedScriptMessageData } from './types';
import type { DistributiveOmit } from '~/types/distributive-omit';
import { RIA_COMMENTS_APP, RIA_COMMENTS_EMBED_SCRIPT } from './constants';

export function isAppMessageData(data: unknown): data is AppMessageData {
  return !!data && typeof data === 'object' && 'sender' in data && data.sender === RIA_COMMENTS_APP;
}

export function isEmbedScriptMessageData(data: unknown): data is EmbedScriptMessageData {
  return !!data && typeof data === 'object' && 'sender' in data && data.sender === RIA_COMMENTS_EMBED_SCRIPT;
}

export function sendAppMessage(dispatcher: Window, data: DistributiveOmit<AppMessageData, 'sender'>): void {
  dispatcher.postMessage(
    {
      ...data,
      sender: RIA_COMMENTS_APP,
    },
    '*'
  );
}

export function sendEmbedScriptMessage(
  dispatcher: Window,
  data: DistributiveOmit<EmbedScriptMessageData, 'sender'>
): void {
  dispatcher.postMessage(
    {
      ...data,
      sender: RIA_COMMENTS_EMBED_SCRIPT,
    },
    '*'
  );
}
